if (!customElements.get('product-description-read-more')) {
	class ProductDescriptionReadMore extends HTMLElement {
		#resizeObserver;

		connectedCallback() {
			this.inner = this.querySelector('.product__description-read-more__inner');
			this.button = this.querySelector('.product__description-read-more__button');

			if (!this.inner || !this.button) return;

			this.moreText = this.button.textContent.trim();
			this.lessText = this.dataset.lessText || 'Daha Az Göster';

			this.#checkOverflow();
			this.button.addEventListener('click', this.#toggle.bind(this));

			this.#resizeObserver = new ResizeObserver(() => this.#checkOverflow());
			this.#resizeObserver.observe(this.inner);
		}

		disconnectedCallback() {
			this.#resizeObserver?.disconnect();
		}

		#checkOverflow() {
			const styles = getComputedStyle(this.inner);
			const lineHeight = parseFloat(styles.lineHeight);

			if (!lineHeight) return;

			const maxHeight = lineHeight * 4.4;
			const needsClamp = this.inner.scrollHeight > maxHeight + 1;

			this.classList.toggle('is-collapsible', needsClamp);

			if (!needsClamp) {
				this.classList.remove('is-expanded');
				this.button.textContent = this.moreText;
				this.button.setAttribute('aria-expanded', 'false');
			}
		}

		#toggle() {
			const expanded = !this.classList.contains('is-expanded');

			this.classList.toggle('is-expanded', expanded);
			this.button.textContent = expanded ? this.lessText : this.moreText;
			this.button.setAttribute('aria-expanded', expanded);
		}
	}

	customElements.define('product-description-read-more', ProductDescriptionReadMore);
}
